import React from "react";
import { useTranslation } from "react-i18next";

import { usePrinterManager } from "~/managers/use-printer-manager";
import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { usePrinterStore } from "~/stores/use-printer-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import PrinterForm from "./printer-form";

export default function PrinterDialog() {
  const {
    selectedPrinter,
    setSelectedPrinter,
    setPrinterDialogOpen,
    printerDialogOpen,
  } = usePrinterStore();

  const { deletePrinter } = usePrinterManager();

  const { t } = useTranslation("common");

  const { checkUnsavedChanges } = useUnsavedChanges();

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedPrinter(undefined);
    }
    setPrinterDialogOpen(open);
  };

  const handleDelete = async () => {
    if (!selectedPrinter?.id) return;
    const result = await deletePrinter(selectedPrinter.id);
    if (result === true) {
      handleDialog(false, true);
    }
  };

  return (
    <Dialog open={printerDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>{t("Printer.printer")}</DialogTitle>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <PrinterForm
            printer={selectedPrinter}
            onClose={(force) => handleDialog(false, force)}
          />
        </div>
        <DialogFooter className="gap-2">
          {selectedPrinter?.id && (
            <Button
              className="text-red-500 w-full"
              onClick={handleDelete}
              variant="ghost"
            >
              {t("delete")}
            </Button>
          )}
          <Button
            type="submit"
            form="printer-form"
            variant="success"
            className="w-full"
          >
            {selectedPrinter ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
